import {caretLeftSvg as Icon__small__caretLeftSvg} from '../Icon__small/Icon__small--caretLeft.js'

export var caretLeft = {
  name: 'caretLeft',
  category: 'icon',
  colorable: true,
  svg: Icon__small__caretLeftSvg,
};
